module.exports = __webpack_public_path__ + "assets/img/90ml.986c9033.svg";